<template>
    <ul class="list-reset text-red text-xs mb-0">
        <li v-for="message in errorMessages">{{ message }}</li>
    </ul>
</template>

<script>
export default {
    props: {
        errorMessages: {
            type: Array,
            required: true,
        },
    },
}
</script>
